import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type CreatePayrixMerchantRequest } from "../../services/api.ts";
import type { CompliancePolicies } from "../../types/payment.ts";

export type FormData = Partial<CreatePayrixMerchantRequest> & {
  bankVerification?: {
    verificationMethod: "plaid" | "manual";
    verificationFile?: {
      name: string;
      size: number;
      type: string;
      content: string; // Base64 encoded file content
    };
    plaidData?: {
      publicToken: string;
      accountToken: string;
      platform: "PLAID";
      institutionName?: string;
      accountName?: string;
      accountMask?: string;
    };
  };
  compliancePolicies?: CompliancePolicies;
};

interface OnboardingState {
  formData: FormData;
  tokenValidated: boolean;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: OnboardingState = {
  formData: {},
  tokenValidated: false,
  status: "idle",
  error: null,
};

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    updateFormData: (state, action: PayloadAction<Partial<FormData>>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    fillDemoData: (state, action: PayloadAction<FormData>) => {
      state.formData = action.payload;
    },
    setTokenValidated: (state, action: PayloadAction<boolean>) => {
      state.tokenValidated = action.payload;
    },
    hydrateOnboarding: (
      state,
      action: PayloadAction<{ formData: FormData; tokenValidated?: boolean }>,
    ) => {
      state.formData = action.payload.formData;
      state.tokenValidated = action.payload.tokenValidated ?? false;
    },
    resetOnboarding: () => initialState,
  },
});

export const {
  updateFormData,
  fillDemoData,
  setTokenValidated,
  hydrateOnboarding,
  resetOnboarding,
} = onboardingSlice.actions;
export default onboardingSlice.reducer;
